import { render, staticRenderFns } from "./HtTrainingBadge.vue?vue&type=template&id=2b8d11b6&scoped=true&"
import script from "./HtTrainingBadge.vue?vue&type=script&lang=js&"
export * from "./HtTrainingBadge.vue?vue&type=script&lang=js&"
import style0 from "./HtTrainingBadge.vue?vue&type=style&index=0&id=2b8d11b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d11b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VContainer,VIcon,VRow})
